import mapboxgl from "mapbox-gl";

import { MAPBOX_KEY } from "./maps";

mapboxgl.accessToken = MAPBOX_KEY;

export default mapboxgl;
